module.exports = __webpack_public_path__ + "static/media/cfc.293be92c.jpg";